import { StationNavigator } from '@app/components/base/stations/StationNavigator';
import { useVideoStations } from '@app/core/stations/hooks/useVideoStations';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import { LiveDot } from '../../../components/playback/LiveDot';
import { LivePlayerMuteControl } from './LivePlayerMuteControl';
import { LivePlayerNewTabControl } from './LivePlayerNewTabControl';
import { LivePlayerPiPControl } from './LivePlayerPiPControl';
import { StationClock } from './StationClock';
import { useLivePlayerSettingsStore } from '../store/live-player-settings.store';

/**
 * Header for the global live player dialog. Shows station navigator, clock,
 * mute/PiP controls, external player action and close button. Contains a drag handle for dialog repositioning.
 */
export function GlobalLivePlayerHeader({ stationId }: { stationId: string }) {
  const setStationId = useLivePlayerSettingsStore((state) => state.setStationId);
  const close = useLivePlayerSettingsStore((state) => state.close);
  const stations = useVideoStations();

  return (
    <Box display="flex" px={1} py={0.5} justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center" gap={1}>
        <LiveDot color="red" size={10} />
        <StationNavigator
          activeId={stationId}
          stations={stations}
          onSelectStation={(station) => setStationId(station.id)}
          size="small"
        />
        <StationClock />
      </Box>
      <Box
        className="drag-handle"
        sx={{
          flex: 1,
          cursor: 'grab',
        }}
      >
        &nbsp;
      </Box>
      <Box display={'flex'} alignItems="center" gap={0.5}>
        <LivePlayerMuteControl />
        <LivePlayerPiPControl />
        <LivePlayerNewTabControl stationId={stationId} />
        <IconButton size="small" onClick={close}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
